'use strict';

const { h } = require('preact');

const PriceLabel = ({
  option: {
    pricing: { pricingLabel },
  },
  showPriceLabel,
}) => {
  if (!pricingLabel || !showPriceLabel) {
    return null;
  }

  return h('span', { class: 'price-label' }, pricingLabel);
};

module.exports = PriceLabel;
